


export enum LoginMode {
	checkToken = 'checkToken',
	loginRequired = 'loginRequired',
	loginFailed = 'loginFailed',
}